import {Component, Input} from '@angular/core';
import {StoryCard} from "../story-card";
import {CdColor} from "../../../enums/cd-color";

@Component({
  selector: 'brt-content-card',
  templateUrl: './content-card.component.html',
  styleUrls: ['./content-card.component.scss']
})
export class ContentCardComponent {
  CdColor = CdColor;

  @Input('card-data') set setCardData(val: StoryCard) {
    this.cardData = val;
  };

  @Input('current') current = false;

  cardData!: StoryCard;
}
